export { default } from "bullitttime-embercomponents/services/results-ajax";
